import React, { useState } from 'react'
import { Eye, EyeOff, RotateCcwKey } from 'lucide-react'
import words from '../../../../assets/words.json'

const PasswordTableInput = ({ password, setPassword }) => {
	const onInputChange = (e) => {
		setPassword(e.target.value)
	}
	function onRandomPasswordClick() {
		const randomPasswort = generateRandomPassword()
		setPassword(randomPasswort)
	}
	return (
		<td style={{ verticalAlign: 'middle' }}>
			<div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
				<input
					type='text'
					value={password || ''}
					placeholder='Passwort'
					onChange={onInputChange}
				/>
				<button
					type='button'
					title='Zufälliges Passwort generieren'
					style={{
						display: 'inline-flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '34px',
						height: '30px',
						border: '1px solid #cfcfcf',
						borderRadius: '4px',
						padding: 1,
						background: '#f7f7f7',
						cursor: 'pointer',
					}}
					onClick={onRandomPasswordClick}
				>
					<RotateCcwKey size={30} strokeWidth={1.5} />
				</button>
			</div>
		</td>
	)
}

function generateRandomPassword() {
	const specialChars = ['!', '?', '#', '$', '%', '&', '*', '+', '-', '_', '@']
	const digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

	const word1 = words[Math.floor(Math.random() * words.length)]
	let word2 = words[Math.floor(Math.random() * words.length)]
	while (word2 === word1) {
		word2 = words[Math.floor(Math.random() * words.length)]
	}

	const base = String(word1) + String(word2)
	const randomSpecialChar =
		specialChars[Math.floor(Math.random() * specialChars.length)]
	const randomDigit = digits[Math.floor(Math.random() * digits.length)]

	const specialIndex = Math.floor(Math.random() * (base.length + 1))
	const withSpecial =
		base.slice(0, specialIndex) + randomSpecialChar + base.slice(specialIndex)

	const digitIndex = Math.floor(Math.random() * (withSpecial.length + 1))
	return (
		withSpecial.slice(0, digitIndex) +
		randomDigit +
		withSpecial.slice(digitIndex)
	)
}

export default PasswordTableInput
